import {MutableRefObject, useCallback, useRef} from 'react';

type DebounceOptions = {
  delay_ms: number;
  fn: (...args: any[]) => void | Promise<void>;
};

const useDebounce = ({delay_ms, fn}: DebounceOptions): ((...args: any[]) => void | Promise<void>) => {
  const timer: MutableRefObject<null | ReturnType<typeof setTimeout>> = useRef(null);

  const debouncedFn = useCallback(
    (...args: any[]) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => fn(...args), delay_ms);
    },
    [fn, delay_ms]
  );

  return debouncedFn;
};

export default useDebounce;
